import { fetchActivityDetail, fetchActivityGoodsList } from '@fetch/activity';
import { fetchGoodsTags } from '@fetch';
// import mock from './../../../views/activity/mock';
const state = {
  bannerList: [],
  adviceList: [],
  goodsList: [],
  headerPosition: {},
  pageTitle: TLang('东方福利网','my'),
  lotteryInfo: [],
};

const getters = {
  bannerList: (state) => state.bannerList,
  adviceList: (state) => state.adviceList,
  goodsList: (state) => state.goodsList,
  headerPosition: (state) => state.headerPosition,
  pageTitle: (state) => state.pageTitle,
  lotteryInfo: (state) => state.lotteryInfo,
};
// 有顺心的异步请求
function* loadData(resourceIds) {
  for (let i = 0; i < resourceIds.length; i++) {
    yield resourceIds[i];
  }
}

const actions = {
  async fetchActivityDetail({ commit, dispatch }, data) {
    const res = await fetchActivityDetail(data);
    try {
      if (res && typeof res === 'object') {
        // commit('fetchActivityDetail', mock.body);
        commit('fetchActivityDetail', res);
        let goodsList = [];
        let resourceIds = [];
        const { advPositionDtos = [] } = res;
        const filterAdvPositionDtos = advPositionDtos.filter(
          (item) => item.platform !== 1,
        );
        goodsList = filterAdvPositionDtos.filter((item) => item.showType === 3);
        // 这里做另一个接口请求 获取商品
        if (goodsList.length) {
          goodsList.map((goodsType3) => {
            if (
              goodsType3.subAdvPositions &&
              goodsType3.subAdvPositions.length
            ) {
              goodsType3.subAdvPositions.map((item) => {
                if (item.showType === 6) {
                  resourceIds.push(item.resourceId);
                }
              });
            }
          });
        }
        dispatch('fetchActivityGoodsList', { resourceIds, goodsList });
      }
    } catch (error) {
      commit('fetchActivityDetail', 0);
    }
    return res;
  },
  fetchActivityGoodsList({ commit }, { goodsList = [], resourceIds = [] }) {
    if (resourceIds.length === 0 || goodsList.length === 0) return;
    const gen = loadData(resourceIds);
    function next() {
      let res = gen.next();
      if (!res.done) {
        fetchActivityGoodsList({ id: res.value }).then((body) => {
          let list = body.goodsList;
          let paramsList = [];
          list&&list.forEach(item => {
            item.subAdvPositions.forEach(goods => {
              if (goods.goodsInfo.goodsId) {
                paramsList.push({ goodsId: goods.goodsInfo.goodsId, categoryId: goods.goodsInfo.categoryId })
              }
            })
          })
          //获取商品tag信息
          fetchGoodsTags({goodsList:paramsList,channel:2}).then(d => {
            if (d && d.length > 0) {
              list.forEach(item => {
                item.subAdvPositions.forEach(goods => {
                  const goodTag = d.find(tag => tag.categoryId == goods.goodsInfo.categoryId && tag.goodsId == goods.goodsInfo.goodsId) || {};
                  let tags = goodTag && goodTag.tags ? goodTag.tags : [];
                  // type 1特价抢购 满减 2爆炸贴 3新品
                  let newTags = tags.filter(item => item.type != 2)
                  let stickerImgList =  tags.filter(item => item.type === 2)
                  const promPrice = goodTag && goodTag.tags ? goodTag.promPrice : null;
                  const salePrice = goodTag && goodTag.tags ? goodTag.salePrice : null;
                  const bizStock = goodTag && goodTag.bizStock >= 0 ? goodTag.bizStock : null;
                  goods.goodsInfo.tags = newTags;
                  goods.goodsInfo.promPrice = promPrice;
                  goods.goodsInfo.salePrice = salePrice;
                  goods.goodsInfo.bizStock = bizStock;
                  // 爆炸贴数据
                  goods.goodsInfo.stickerImgList = stickerImgList;
                  // 拼接折扣信息
                  goods.goodsInfo.discount = goodTag.discount;
                  goods.goodsInfo.discountPrice = goodTag.discountPrice;
                  goods.goodsInfo.discountTagShow = goodTag.discountTagShow;
                  goods.goodsInfo.mktTagShow = goodTag.mktTagShow;
                  // 福拼拼相关字段
                  // Y 为福拼拼
                  goods.goodsInfo.groupItem = goodTag.groupItem;
                  // groupItemClassStyle 样式 1、文本模式，2、+货币模式
                  goods.goodsInfo.groupItemClassStyle = goodTag.groupItemClassStyle;
                  // 拼团价格
                  goods.goodsInfo.groupItemPrice = goodTag.groupItemPrice;
                  // 拼团价格限制 最高可抵扣福豆
                  goods.goodsInfo.groupItemPriceLimit = goodTag.groupItemPriceLimit;
                  // 拼团商品是否显示人命币 Y:是 N:否
                  goods.goodsInfo.groupItemShowRmbSymbol = goodTag.groupItemShowRmbSymbol;
                })
              })
            }
            try {
              commit('setGoodsList', body || {});
              next();
            } catch (error) {
              console.log(error)
            }
          })
          // commit('setGoodsList', body || {});
          // next();
        });
      }
    }
    next();
  },
};

const mutations = {
  fetchActivityDetail(state, payload) {
    let headerPosition = {};
    let goodsList = [];
    let lotteryInfo = [];
    const adviceList = [];
    const { advPositionDtos = [] } = payload;
    const filterAdvPositionDtos = advPositionDtos.filter(
      (item) => item.platform !== 1,
    );
    if (
      filterAdvPositionDtos[0] &&
      filterAdvPositionDtos[0].showType === 1 &&
      filterAdvPositionDtos[0].platform === 0
    ) {
      // eslint-disable-next-line prefer-destructuring
      headerPosition = filterAdvPositionDtos[0];
    }
    // showType === 3 为楼层商品
    goodsList = filterAdvPositionDtos.filter((item) => item.showType === 3);
    lotteryInfo = filterAdvPositionDtos.filter((item) => item.showType === 7);
    // console.log(goodsList);
    if (filterAdvPositionDtos.length > 0) {
      filterAdvPositionDtos.map((item) => {
        if (item.showType === 2 && item.images && item.images.length > 0) {
          item.images.map((img) => state.bannerList.push(img));
        }
        if (item.showType === 1) {
          adviceList.push(item);
        }
      });
    }
    if (headerPosition.imagePath) {
      adviceList.shift();
    }
    state.headerPosition = headerPosition;
    state.goodsList = goodsList;
    state.lotteryInfo = lotteryInfo;
  },
  setGoodsList({ goodsList }, payload) {
    // let goodsList = goodsList;
    // console.log(goodsList,'goodsList')
    if (goodsList.length) {
      goodsList.map((goodsType3) => {
        if (goodsType3.subAdvPositions && goodsType3.subAdvPositions.length) {
          goodsType3.subAdvPositions.map((item) => {
            // 重新组合
            if (item.resourceId == payload.id) {
              item.subAdvPositions = payload.goodsList;
              // 没有商品把这个标签也干掉
              if (!payload.goodsList || payload.goodsList.length === 0) {
                goodsType3.subAdvPositions = [];
              }
            }
          });
        }
      });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
